import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/variables.css';
import './styles/globals.css';
// Importar logo para favicon
import goheadspringLogo from './img/goheadspring_logo.png';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Reemplazar favicon dinámicamente
const existingFavicon = document.querySelector("link[rel*='icon']");
if (existingFavicon instanceof HTMLLinkElement) {
  existingFavicon.href = goheadspringLogo;
} else {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = goheadspringLogo;
  document.head.appendChild(link);
}
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
